import { CapoPlugin } from "/root/new-qanotsharq-frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];